module.exports = __webpack_public_path__ + "media/images/globe-63dc23800d46cb80a450299e30ae4b0b.svg";